<template>
    <div>
        <c-search-form :input-search-items="searchItems" :rows-per-page-items="[10,20,50]"
                       :input-create-items="createItems"
                       :form-name="formName"
                       :create-form="$t('lang.procedure.createForm')"
                       :fields="fields" accept-copy
                       key-property="procedureId"
                       search-url="/procedure/search"
                       create-url="/procedure/save"
                       delete-url="/procedure/delete"
                       form-type="intable"
                       @onDocument="onDocument"
                       @onFee="onFee"
                       @onFileDocument="onFileDocument"

        >
        </c-search-form>
        <v-dialog v-model="feeDlg" width="1200px">
            <v-card>
                <v-card-title>
                    <div class="headline dialog-header">
                        <v-btn @click="feeDlg=false" icon style="float: left">
                            <v-icon>close</v-icon>
                        </v-btn>
                        Phí của thủ tục
                    </div>
                </v-card-title>
                <v-card-text>
                    <procedure-fee @cancel="feeDlg = false" ref="fee"/>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="documentDlg" width="1200px">
            <v-card>
                <v-card-title>
                    <div class="headline dialog-header">
                        <v-btn @click="documentDlg=false" icon style="float: left">
                            <v-icon>close</v-icon>
                        </v-btn>
                        Tài liệu theo các bước thủ tục
                    </div>
                </v-card-title>
                <v-card-text>
                    <procedure-document @cancel="documentDlg = false" ref="document"/>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="fileDocumentDlg" width="1200px">
            <v-card>
                <v-card-title>
                    <div class="headline dialog-header">
                        <v-btn @click="fileDocumentDlg=false" icon style="float: left">
                            <v-icon>close</v-icon>
                        </v-btn>
                        Tài liệu của thủ tục
                    </div>
                </v-card-title>
                <v-card-text>
                    <procedure-file-document @cancel="fileDocumentDlg = false" ref="fileDocument"/>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import CSearchForm from "../../../components/form/ManageForm";
    import ProcedureCreate from "./ProcedureCreate";
    import axios from "axios";
    import ProcedureFee from "./ProcedureFee";
    import ProcedureDocument from "./ProcedureDocument";
    import ProcedureFileDocument from "./ProcedureFileDocument";

    export default {
        name: 'procedure-management',
        components: {ProcedureFileDocument, ProcedureDocument, ProcedureFee, ProcedureCreate, CSearchForm},
        data: () => {
            return {
                formName: "lang.procedure.title",
                searchItems: [
                    {
                        type: "text",
                        name: "procedureCode",
                        label: "lang.procedure.code",
                        placeHolder: "",
                        focus: true
                    },
                    {
                        type: "text",
                        name: "procedureName",
                        label: "lang.procedure.name",
                        placeHolder: ""
                    }
                ],
                createItems: [
                    {
                        type: "text",
                        name: "procedureCode",
                        label: "lang.procedure.code",
                        validate: "required",
                        maxlength: '50',
                        placeHolder: "",
                        focus: true
                    },
                    {
                        type: "text",
                        name: "procedureName",
                        label: "lang.procedure.name",
                        validate: "required",
                        maxlength: '250',
                        placeHolder: "",
                    },
                    {
                        type: "select",
                        name: "area",
                        label: "lang.procedure.area",
                        validate: "required",
                        itemText: "text",
                        itemValue: "value",
                        items: [
                            {
                                "text": "Sáng chế/Giải pháp hữu ích",
                                "value": 1
                            },
                            {
                                "text": "Nhãn hiệu",
                                "value": 2
                            },
                            {
                                "text": "Kiểu dáng công nghiệp",
                                "value": 3
                            },
                            {
                                "text": "Thiết kế bo mạch",
                                "value": 4
                            },
                            {
                                "text": "Chỉ dẫn địa lý",
                                "value": 5
                            },
                        ]
                    },
                    {
                        type: "select",
                        name: "flowConfig",
                        label: "lang.procedure.config",
                        validate: "required",
                        itemText: "flowName",
                        itemValue: "flowCode",
                        items: []
                    }

                ],
                fields: [
                    {value: "checkbox", sortable: false, headerStyle: "text-align:center",width:"5%"},
                    {
                        value: "index",
                        text: "lang.common.index",
                        width: "5%",
                        sortable: false,
                        headerStyle: "text-align:center"
                    },
                    {
                        value: 'procedureCode',
                        text: 'lang.procedure.code',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'procedureName',
                        text: 'lang.procedure.name',
                        width: "15%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'area',
                        text: 'lang.procedure.area',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'flowName',
                        text: 'lang.procedure.config',
                        width: "20%",
                        sortable: false,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'custom_action',
                        text: "lang.procedure.fee",
                        icon: "attach_money",
                        event: "onFee",
                        width: "10%",
                        color: "info"
                    },
                    {
                        value: 'custom_action',
                        text: "lang.procedure.documentOfFile",
                        icon: "mdi-file-document-outline",
                        event: "onFileDocument",
                        width: "10%",
                        color: "info"
                    },
                    {
                        value: 'custom_action',
                        text: "lang.procedure.documentOfTask",
                        icon: "folder_shared",
                        event: "onDocument",
                        width: "10%",
                        color: "primary"
                    },
                    {
                        value: 'action',
                        text: "lang.common.actions",
                        width: "15%",
                        sortable: false,
                        compound: true,
                        headerStyle: "text-align:center"
                    }
                ],
                selectProc: null,
                feeDlg: false,
                documentDlg: false,
                fileDocumentDlg:false
            }
        },
        created() {
            axios.post(process.env.VUE_APP_API_URL + "/workflow/search?page=0&pageSize=-1", {}).then(
                data => {
                    this.createItems[3].items = data.items;
                    console.log(this.createItems);
                }
            )
        },
        computed:{
        },

        methods: {
            onDocument(item) {
                this.documentDlg = true;
                this.$refs.document.viewProcedureDocument(item);
            },

            onFee(item) {
                this.selectProc = item;
                this.feeDlg = true;
                this.$refs.fee.viewProcedureFee(item);
            },
            onFileDocument(item){
                this.selectProc = item;
                this.fileDocumentDlg = true;
                this.$refs.fileDocument.viewProcedureDocument(item);

            }
        },

        destroyed() {
        }
    }
</script>
